interface FileExplorerErrorStateProps {
  categoryError?: Error | null;
}

export function FileExplorerErrorState({
  categoryError,
}: FileExplorerErrorStateProps) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <h2 className="text-lg font-semibold text-ink-900">
        Category not found
      </h2>
      <p className="text-sm text-ink-600">
        {categoryError
          ? "Failed to load category. Please try again."
          : "The category you're looking for does not exist."}
      </p>
    </div>
  );
}

